var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWovenImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_712_3506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.75 17H1.25C0.836 17 0.5 17.336 0.5 17.75C0.5 18.164 0.836 18.5 1.25 18.5H23.75C24.164 18.5 24.5 18.164 24.5 17.75C24.5 17.336 24.164 17 23.75 17Z",
    fill: "#F8CD80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.75 20H1.25C0.836 20 0.5 20.336 0.5 20.75C0.5 21.164 0.836 21.5 1.25 21.5H23.75C24.164 21.5 24.5 21.164 24.5 20.75C24.5 20.336 24.164 20 23.75 20Z",
    fill: "#F8CD80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.75 23H1.25C0.836 23 0.5 23.336 0.5 23.75C0.5 24.164 0.836 24.5 1.25 24.5H23.75C24.164 24.5 24.5 24.164 24.5 23.75C24.5 23.336 24.164 23 23.75 23Z",
    fill: "#F8CD80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.75 0.5H2.25C1.29 0.5 0.5 1.29 0.5 2.25V13.75C0.5 14.71 1.29 15.5 2.25 15.5H22.75C23.71 15.5 24.5 14.71 24.5 13.75V2.25C24.5 1.29 23.71 0.5 22.75 0.5ZM2 2.25C2 2.11 2.11 2 2.25 2H22.75C22.89 2 23 2.11 23 2.25V6.99L20.7 4.94C20.02 4.33 18.97 4.36 18.3 5.01L12.7 10.62L12.38 10.68C12.36 10.67 12.34 10.66 12.32 10.64L8.71 7.03C8.04 6.36 6.97 6.34 6.28 6.98L2 10.94V2.25Z",
    fill: "#F79A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_712_3506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWovenImage);
export default __webpack_public_path__ + "static/media/WovenImage.c7bdfa93c9f88f8b56401995a3ff9bda.svg";
export { ForwardRef as ReactComponent };